interface Entry {
  meta: { url: string }
  error: () => void
  progress: (n: number) => void
  file: any
}

function ImageUploader(entries: Entry[], onViewError: (fn: () => void) => void) {
  entries.forEach((entry) => {
    const { url } = entry.meta

    const xhr = new XMLHttpRequest()
    // true - for async
    xhr.open('PUT', url, true)
    xhr.setRequestHeader('Content-type', 'image')

    onViewError(() => xhr.abort())
    xhr.onerror = () => entry.error()
    xhr.onload = () => {
      const isSuccess = xhr.status === 204 || xhr.status === 200
      isSuccess ? entry.progress(100) : entry.error()
    }
    xhr.upload.addEventListener('progress', (event) => {
      if (event.lengthComputable) {
        let percent = Math.round((event.loaded / event.total) * 100)
        if (percent < 100) {
          entry.progress(percent)
        }
      }
    })

    xhr.send(entry.file)
  })
}

export { ImageUploader }
